// extracted by mini-css-extract-plugin
export default {"pageCloseButton":"page-close-button_pageCloseButton__+Sker"};